type Backend = 'api-consent' | 'api-4p';

export interface GetBackendUriOptions {
  /** COMS backend name, i.e., "api-consent" or "api-4p" */
  backend: Backend;
  /** gateway context, e.g., "/coms/v2", may contain placeholders "{env}", "{-env}", "{/env}" */
  gatewayContext: string;
}

const localPortMap: Record<Backend, number> = {
  'api-consent': 3000,
  'api-4p': 3200,
};

const gwMap: Record<string, { gwEnv: string, gwSuffix: string, useQualified: boolean } | undefined> = {
  ict: { gwEnv: 'ict', gwSuffix: 'test', useQualified: false },
  e2e2: { gwEnv: 'e2e2', gwSuffix: 'test', useQualified: false },
  e2e1: { gwEnv: 'e2e1', gwSuffix: 'test', useQualified: false },
  nfr: { gwEnv: 'perf', gwSuffix: 'test', useQualified: false }, // nfr -> perf (sic!)
  prod: { gwEnv: 'prod', gwSuffix: 'prod', useQualified: false },
  ort: { gwEnv: 'ort', gwSuffix: 'prod', useQualified: true },
  fallback: { gwEnv: 'ict', gwSuffix: 'test', useQualified: true },
};

/** guess the backend url via API Gateway depending on `window.location` */
export const getBackendUri = (options: GetBackendUriOptions) => {
  const { backend, gatewayContext } = options;
  const { hostname, protocol } = window.location;

  if (['localhost', '0.0.0.0', '127.0.0.1'].includes(hostname)
    || hostname.startsWith('192.168') || hostname.startsWith('10.')) {
    return `${protocol}//${hostname}:${localPortMap[backend]}`;
  }

  const env = /^(?<env>.*?)-micro-frontend-proxy/.exec(hostname)?.groups?.env ?? 'ict';

  const { gwEnv, gwSuffix, useQualified } = gwMap[env] ?? gwMap.fallback!;

  const gwPath = gatewayContext
    .replace('{env}', useQualified ? env : '')
    .replace('{-env}', useQualified ? `-${env}` : '')
    .replace('{/env}', useQualified ? `/${env}` : '');

  const slash = gwPath.startsWith('/') ? '' : '/';

  return `https://${gwEnv}.high.apigw-${gwSuffix}.aws.de.pri.o2.com/gateway${slash}${gwPath}`;
};
